// extracted by mini-css-extract-plugin
export default {"container":"shopAdminSidePanel_container__tO++h","main":"shopAdminSidePanel_main__XDjNp"};